import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetVehicleProjectMasterRegDocQueryQueryVariables = Types.Exact<{
  queryArgAssignedRegDocs: Types.QueryArgsAssignedEntityInput;
}>;


export type GetVehicleProjectMasterRegDocQueryQuery = { __typename?: 'Query', vehicleProjectMasterRegDocQuery: { __typename?: 'RegDocInfinityResults', regDocIds: Array<string>, regDocFilterOptions: { __typename?: 'RegDocFilterOptions', regulationOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, statusOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, workFlowOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, marketOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, mainKeywordOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', optionKey: string, name: string }> }, regDocsBatch: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, disassemblyStatus: Types.RegulatoryDocumentDisassemblyStatus, dateEffective?: any | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus }, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }> } | null }>, requirementCountPerRegDoc?: Array<{ __typename?: 'KeyValuePairOfStringAndInt32', key: string, value: number }> | null, projectRelevancyPerRegDoc?: Array<{ __typename?: 'KeyValuePairOfStringAndBoolean', key: string, value: boolean }> | null } };

export type GetVehicleProjectRegDocNextQueryVariables = Types.Exact<{
  nextArgs: Types.NextArgsInput;
}>;


export type GetVehicleProjectRegDocNextQuery = { __typename?: 'Query', voProRegDocNext: Array<{ __typename?: 'RegulatoryDocument', id: string, name: string, status: Types.RegulatoryDocumentStatus, disassemblyStatus: Types.RegulatoryDocumentDisassemblyStatus, dateEffective?: any | null, markets: Array<{ __typename?: 'Market', id: string, name: string }>, workflow: { __typename?: 'Workflow', status: Types.WorkflowStatus }, regulation?: { __typename?: 'Regulation', id: string, regulationNumber: string, name: string, markets: Array<{ __typename?: 'Market', id: string, name: string }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }> } | null }> };

export type GetVehicleProjectRegDocSortOrderQueryVariables = Types.Exact<{
  sortArgs: Types.SortArgsInput;
}>;


export type GetVehicleProjectRegDocSortOrderQuery = { __typename?: 'Query', voProRegDocSortOrder: Array<string> };


export const GetVehicleProjectMasterRegDocQueryDocument = gql`
    query GetVehicleProjectMasterRegDocQuery($queryArgAssignedRegDocs: QueryArgsAssignedEntityInput!) {
  vehicleProjectMasterRegDocQuery(
    queryArgAssignedRegDocs: $queryArgAssignedRegDocs
  ) {
    regDocIds
    regDocFilterOptions {
      regulationOptions {
        optionKey
        name
      }
      statusOptions {
        optionKey
        name
      }
      workFlowOptions {
        optionKey
        name
      }
      marketOptions {
        optionKey
        name
      }
      mainKeywordOptions {
        optionKey
        name
      }
      keywordOptions {
        optionKey
        name
      }
    }
    regDocsBatch {
      id
      name
      status
      disassemblyStatus
      dateEffective
      markets {
        id
        name
      }
      workflow {
        status
      }
      regulation {
        id
        regulationNumber
        name
        markets {
          id
          name
        }
        mainKeywords {
          id
          name
        }
        keywords {
          id
          name
        }
        standardPlusPcmsClusters {
          id
          name
        }
      }
    }
    requirementCountPerRegDoc {
      key
      value
    }
    projectRelevancyPerRegDoc {
      key
      value
    }
  }
}
    `;

/**
 * __useGetVehicleProjectMasterRegDocQueryQuery__
 *
 * To run a query within a React component, call `useGetVehicleProjectMasterRegDocQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleProjectMasterRegDocQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleProjectMasterRegDocQueryQuery({
 *   variables: {
 *      queryArgAssignedRegDocs: // value for 'queryArgAssignedRegDocs'
 *   },
 * });
 */
export function useGetVehicleProjectMasterRegDocQueryQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleProjectMasterRegDocQueryQuery, GetVehicleProjectMasterRegDocQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleProjectMasterRegDocQueryQuery, GetVehicleProjectMasterRegDocQueryQueryVariables>(GetVehicleProjectMasterRegDocQueryDocument, options);
      }
export function useGetVehicleProjectMasterRegDocQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleProjectMasterRegDocQueryQuery, GetVehicleProjectMasterRegDocQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleProjectMasterRegDocQueryQuery, GetVehicleProjectMasterRegDocQueryQueryVariables>(GetVehicleProjectMasterRegDocQueryDocument, options);
        }
export type GetVehicleProjectMasterRegDocQueryQueryHookResult = ReturnType<typeof useGetVehicleProjectMasterRegDocQueryQuery>;
export type GetVehicleProjectMasterRegDocQueryLazyQueryHookResult = ReturnType<typeof useGetVehicleProjectMasterRegDocQueryLazyQuery>;
export type GetVehicleProjectMasterRegDocQueryQueryResult = Apollo.QueryResult<GetVehicleProjectMasterRegDocQueryQuery, GetVehicleProjectMasterRegDocQueryQueryVariables>;
export const GetVehicleProjectRegDocNextDocument = gql`
    query GetVehicleProjectRegDocNext($nextArgs: NextArgsInput!) {
  voProRegDocNext(nextArgs: $nextArgs) {
    id
    name
    status
    disassemblyStatus
    dateEffective
    markets {
      id
      name
    }
    workflow {
      status
    }
    regulation {
      id
      regulationNumber
      name
      markets {
        id
        name
      }
      mainKeywords {
        id
        name
      }
      keywords {
        id
        name
      }
      standardPlusPcmsClusters {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetVehicleProjectRegDocNextQuery__
 *
 * To run a query within a React component, call `useGetVehicleProjectRegDocNextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleProjectRegDocNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleProjectRegDocNextQuery({
 *   variables: {
 *      nextArgs: // value for 'nextArgs'
 *   },
 * });
 */
export function useGetVehicleProjectRegDocNextQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleProjectRegDocNextQuery, GetVehicleProjectRegDocNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleProjectRegDocNextQuery, GetVehicleProjectRegDocNextQueryVariables>(GetVehicleProjectRegDocNextDocument, options);
      }
export function useGetVehicleProjectRegDocNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleProjectRegDocNextQuery, GetVehicleProjectRegDocNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleProjectRegDocNextQuery, GetVehicleProjectRegDocNextQueryVariables>(GetVehicleProjectRegDocNextDocument, options);
        }
export type GetVehicleProjectRegDocNextQueryHookResult = ReturnType<typeof useGetVehicleProjectRegDocNextQuery>;
export type GetVehicleProjectRegDocNextLazyQueryHookResult = ReturnType<typeof useGetVehicleProjectRegDocNextLazyQuery>;
export type GetVehicleProjectRegDocNextQueryResult = Apollo.QueryResult<GetVehicleProjectRegDocNextQuery, GetVehicleProjectRegDocNextQueryVariables>;
export const GetVehicleProjectRegDocSortOrderDocument = gql`
    query GetVehicleProjectRegDocSortOrder($sortArgs: SortArgsInput!) {
  voProRegDocSortOrder(sortArgs: $sortArgs)
}
    `;

/**
 * __useGetVehicleProjectRegDocSortOrderQuery__
 *
 * To run a query within a React component, call `useGetVehicleProjectRegDocSortOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleProjectRegDocSortOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleProjectRegDocSortOrderQuery({
 *   variables: {
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useGetVehicleProjectRegDocSortOrderQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleProjectRegDocSortOrderQuery, GetVehicleProjectRegDocSortOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleProjectRegDocSortOrderQuery, GetVehicleProjectRegDocSortOrderQueryVariables>(GetVehicleProjectRegDocSortOrderDocument, options);
      }
export function useGetVehicleProjectRegDocSortOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleProjectRegDocSortOrderQuery, GetVehicleProjectRegDocSortOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleProjectRegDocSortOrderQuery, GetVehicleProjectRegDocSortOrderQueryVariables>(GetVehicleProjectRegDocSortOrderDocument, options);
        }
export type GetVehicleProjectRegDocSortOrderQueryHookResult = ReturnType<typeof useGetVehicleProjectRegDocSortOrderQuery>;
export type GetVehicleProjectRegDocSortOrderLazyQueryHookResult = ReturnType<typeof useGetVehicleProjectRegDocSortOrderLazyQuery>;
export type GetVehicleProjectRegDocSortOrderQueryResult = Apollo.QueryResult<GetVehicleProjectRegDocSortOrderQuery, GetVehicleProjectRegDocSortOrderQueryVariables>;